/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.donations.amount.controllers', [])

.controller('DonationsAmountController', ['$scope', function($scope) {

    $scope.donationsAmount = {

      model: "Your spankin new application.donations.amount view!",

      init: function() {},

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.donationsAmount.init();

}]);